



























































































































































  import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

  import DetailProfileHeader from '../../types/app/detailProfileHeader';
import Header from '../../types/app/header';
import Endpoint from '../../utils/endpoint';

  import Menu from '@/types/profile/menu';
import Permission from '@/types/profile/permission';
import Application from '../../types/app/application';
import Profile from '../../types/app/profile';
import Area from '../../types/profile/area';
import User from '../../types/user/user';

  @Component({})
  export default class UserForm extends Vue {
    @Getter('getUser', { namespace: 'auth' }) loggedUser!: User;

    @Action('setSnackbar', { namespace: 'app' }) setSnackbar!: any;
    @Action('setOverlay', { namespace: 'app' }) setOverlay!: any;

    headers: Array<Header> = DetailProfileHeader.header;
    rules = [(v: any) => !!v || 'This field is required'];

    valid = null;
    dialog = false;
    saving = false;
    loading = false;
    isCreate = true;
    gettingApplications = true;

    applicationId = null;

    selected: Array<Profile> = [];
    applications: Array<Application> = [];
    profiles: Array<Profile> = [];

    profileAreas: Array<Area> = [];
    allAreas: Array<Area> = [];

    user: User = {
      id: null,
      email: null,
      typeUser: null,
      profiles: null
    };

    async created() {
      this.isCreate = !this.$route.params.id;

      if (!this.isCreate) {
        this.loading = true;
        await this.getUser();
      }

      await this.getApplications();
      await this.getAreas();
    }

    get areas(): Array<Area> {
      const retVal: Array<Area> = [];

      if (this.allAreas && this.profileAreas) {
        this.allAreas.forEach((matrix: Area) => {
          const profileArea = this.profileAreas.find(x => x.title == matrix.title);
          if (profileArea) {
            matrix.menus.forEach((menu: Menu) => {
              const profileMenu = profileArea.menus.find(x => x.title == menu.title);
              if (profileMenu) {
                menu.flgInclude = true;
                menu.permissions.forEach((permission: Permission) => {
                  const profilePermission = profileMenu.permissions.find(x => x.action == permission.action);

                  permission.active = profilePermission ? profilePermission.active : false;
                  permission.flgActive = true;
                });
              } else {
                menu.flgInclude = false;
              }
            });
          } else {
            matrix.menus.forEach((menu: Menu) => {
              menu.flgInclude = false;
              if (menu.permissions && menu.permissions.length > 0) {
                menu.permissions.forEach((permission: Permission) => {
                  permission.active = false;
                  permission.flgActive = false;
                });
              }
            });
          }

          retVal.push(matrix);
        });
      }

      return retVal;
    }

    async getUser(): Promise<void> {
      try {
        const resp = await this.$http.get(`${Endpoint.Url.user.getById}/${this.$route.params.id}`);

        this.user = resp.data;
        console.log('user', JSON.parse(JSON.stringify(this.user)));
        console.log(this.user.email, this.loggedUser.email);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log('error', error);
      }
    }

    async getApplications(): Promise<void> {
      try {
        const resp: any = await this.$http.get(Endpoint.Url.profile.getApplications);

        if (resp.statusCode.item1 === 200) {
          this.applications = resp.data;
        }

        this.gettingApplications = false;
      } catch (error) {
        this.gettingApplications = false;
        console.log('error');
      }
    }

    async getProfiles(): Promise<void> {
      try {
        this.loading = true;
        const resp: any = await this.$http.get(`${Endpoint.Url.profile.getProfiles}/${this.applicationId}`);

        if (this.user.profiles) {
          this.selected = this.user.profiles.filter(x => x.applicationId == this.applicationId);
        }

        if (resp.statusCode.item1 === 200) {
          console.log('profiles', JSON.parse(JSON.stringify(resp.data)));

          this.profiles = resp.data;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log('error', error);
      }
    }

    async getAreas(): Promise<void> {
      try {
        const response = await this.$http.get(Endpoint.Url.profile.getAllAreas);
        if (response.data && response.data.length > 0) {
          response.data.forEach((area: Area) => {
            if (area.title) {
              this.allAreas.push(area);
            }
          });
        }
      } catch (error) {
        console.log('error', error);
      }
    }

    async saveAsync(): Promise<void> {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        this.saving = true;
        if (this.isCreate) {
          await this.createAsync();
        } else {
          await this.updateAsync();
        }
      }
    }

    async createAsync(): Promise<void> {
      try {
        const resp: any = await this.$http.post(`${Endpoint.Url.user.create}/${this.applicationId}`, {
          id: this.user.id,
          email: this.user.email,
          typeUser: this.user.typeUser,
          profiles: this.selected.map(x => x.id)
        });

        if (resp.hasStatusErrors) {
          this.setSnackbar({
            show: true,
            message: `${resp.statusCode.item2} (${resp.statusCode.item1})`,
            color: 'error'
          });
        } else {
          this.setSnackbar({
            show: true,
            message: 'created with Success',
            color: 'success'
          });

          this.$router.push({ name: 'IndexUser' });
        }
        this.saving = false;
      } catch (error) {
        this.saving = false;
        this.setSnackbar({
          show: true,
          message: `Error to create`,
          color: 'error'
        });

        console.log('error', error);
      }
    }

    async updateAsync(): Promise<void> {
      const user = {
        id: this.user.id,
        email: this.user.email,
        typeUser: this.user.typeUser,
        profiles: this.selected.map(x => x.id)
      };

      try {
        const resp: any = await this.$http.put(`${Endpoint.Url.user.update}/${this.applicationId}`, user);

        if (resp.hasStatusErrors) {
          this.setSnackbar({
            show: true,
            message: `${resp.statusCode.item2} (${resp.statusCode.item1})`,
            color: 'error'
          });
        } else {
          this.setSnackbar({
            show: true,
            message: `updated with Success`,
            color: 'success'
          });

          this.$router.push({ name: 'IndexUser' });
        }
        this.saving = false;
      } catch (error) {
        this.saving = false;
        this.setSnackbar({
          show: true,
          message: `Error to update`,
          color: 'error'
        });

        console.log('error', error);
      }
    }

    closeDetail(): void {
      this.dialog = false;
      this.profileAreas = [];
    }

    async goToDetail(item: any): Promise<void> {
      try {
        this.setOverlay(true);
        const response = await this.$http.get(`${Endpoint.Url.profile.getById}/${item.id}`);

        if (response.data && response.data.areas.length > 0) {
          response.data.areas.forEach((area: Area) => {
            if (area.title) {
              this.profileAreas.push(area);
            }
          });
        }
        this.setOverlay(false);
        this.dialog = true;
        this.loading = false;
      } catch (error) {
        console.log('error', error);
      }
    }
  }
